/**
 * 注册端内js脚本
 * self 页面this
 */
import { getOSType } from './IssJsBridgeCourier/utils'
import { EOSType } from './IssJsBridgeCourier/consts'
export const registerApp = (self: any) => {
//   window['lightning'] = self
//   if (getOSType() === EOSType.android && !window.lightning) {
//     window.lightning = {}
//   }
  if (!window.lightning) {
    window.lightning = {}
  }
  //   if (!window.lightning) {
  //     window.lightning = {}
  //   }
  window.lightning.backable = self.backable
  window.lightning.clothImgCallBack = self.clothImgCallBack
  window.titleTextClick = self.titleTextClick
}

/**
 * 端内返回按钮协议
 * params {object} 需要返回给端内的操作项
 */
const DefaultParams = {
  handleByHtml: true,
  url: '',
  script: '',
  protocolType: 1
}
export const titleBack = (obj: object = DefaultParams) => {
  const host = location.protocol + '//' + location.hostname
  const params = {
    handleByHtml: obj.handleByHtml || true,
    protocolEntity: {
      url: host + obj.url || '',
      script: obj.script || ''
    },
    protocolType: obj.protocolType || 1
  }
  const paramsEncode = encodeURIComponent(JSON.stringify(params))
  window.location.href = 'iss://courier/web/titleBack/' + paramsEncode
}

/**
 * h5导航栏控制协议，后续根据自己需求可以扩展，要考虑好兼容
 */
export const H5CloseBtn = (back = true, topage = '', close = false) => {
  // 去掉h5关闭导航栏按钮
  if (window.TitleControlJS) {
    const param = {
      back: {
        isShow: back
      },
      close: {
        isShow: close,
        toPage: topage // "recruit-progress"
      }
    }
    const titleControl = JSON.stringify(param)
    window.TitleControlJS.handleTitle(titleControl)
  }
}

/**
 * 打开招募目录页协议
 */
export const openRecruit = () => {
  if (window.RecruitJs) {
    window.RecruitJs.openRecruitDirectory()
  }
}

/**
 * 招募转城成功打开首页
 */
export const openIndex = () => {
  if (window.RecruitJs) {
    window.RecruitJs.openIndex()
  }
}

/**
 * 招募完成
 */
export const recruitFinish = (params) => {
  if (window.RecruitJs) {
    window.RecruitJs.recruitFinish(params)
  }
}

// 判断安卓版本号
export const getAndroidApiLevel = (): number => {
  let num = 24
  if (window.RequestJS) {
    num = window.RequestJS.getAndroidApiLevel()
  }
  return num
}

// 关闭交通工具
export const getCloseVehicle = (params: any) => {
  const transportIdEncoded = encodeURIComponent(JSON.stringify(params))
  window.location.href = `shansongyuan://CloseVehicle/${transportIdEncoded}`
}
// 老协议 联系客服
export const connectCustomer = () => {
  window.location.href = 'shansongyuan://OpenCustomerService:/'
}

// 回端内首页
export const gobackHomepage = () => {
  window.location.href = 'iss://courier/main/index'
}

export const setTitleControl = (back, close) => {
  // 移除h5关闭导航栏按钮
  if (window.TitleControlJS) {
    const param = {
      back: {
        isShow: back
      },
      close: {
        isShow: close
      }
    }
    window.TitleControlJS.handleTitle(JSON.stringify(param))
  }
}
/**
 * 关闭所有h5页面
 */
export const closeH5 = () => {
  window.location.href = 'shansongyuan://Close/'
}

// 滑块验证码
export const smartCaptchaValidationJs = (param) => {
  if (window.SlidingValidationJs) {
    window.SlidingValidationJs.verifySuccess(JSON.stringify(param))
  }
}
